import Cookies from "js-cookie";
import React, { createContext, useReducer } from "react";

export const AdminContext = createContext();

const readAdminCookie = () => {
  try {
    const raw = Cookies.get("adminInfo");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Must be the admin object itself (with email), not the full login API wrapper
    if (parsed?.email) return parsed;
    if (parsed?.Admin?.email) return { ...parsed.Admin, token: parsed.token || parsed.Admin.token };
    return null;
  } catch (e) {
    Cookies.remove("adminInfo");
    return null;
  }
};

const initialState = {
  adminInfo: readAdminCookie(),
};

function reducer(state, action) {
  switch (action.type) {
    case "USER_LOGIN":
      return { ...state, adminInfo: action.payload };

    case "USER_LOGOUT":
      return {
        ...state,
        adminInfo: null,
      };

    default:
      return state;
  }
}

export const AdminProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return (
    <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
  );
};
